import type { BrandSpecialUserSegments } from '@iheartjane/types';

export const extractUserSegments = ({
  brandSpecial,
}: {
  brandSpecial: BrandSpecialUserSegments;
}) => ({
  includes: brandSpecial.include_user_segments ?? [],
  excludes: brandSpecial.exclude_user_segments ?? [],
});
